import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuard } from './services/canactivate.service';
import { CanDeactivateGuard } from './services/deactivate.service';
import { SignupComponent } from './signup/signup.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  // { path: 'dashboard', component: SignupComponent },
  { path: 'npp-dashboard', loadChildren: 'src/app/npp-dashboard/npp-dashboard.module#NppDashboardModule', canActivate: [AuthGuard] },
  {
    path: 'dashboard', component: DashboardComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', loadChildren: 'src/app/home/home.module#HomeModule', canActivate: [AuthGuard] },
     
      { path: 'usermanagement', loadChildren: 'src/app/usermanagement/usermanagement.module#UsermanagementModule', canActivate: [AuthGuard] },
     
      { path: 'changepassword', loadChildren: 'src/app/change-password/change-password.module#ChangepasswordModule' },
    
      { path: 'vave', loadChildren: 'src/app/vave/vave.module#VaveModule', canActivate: [AuthGuard]},
      // {path:'ra-kto',loadChildren:'src/app/ra-kto/ra-kto.module#RaKtoModule'}
    ]
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, { useHash: false,
      scrollPositionRestoration: 'top'
    })
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule { }
